/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BreadcrumbsInputs */

const sv_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brödsmulor`)
};

const en_breadcrumbs = /** @type {(inputs: BreadcrumbsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breadcrumbs`)
};

/**
* | output |
* | --- |
* | "Breadcrumbs" |
*
* @param {BreadcrumbsInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const breadcrumbs = /** @type {((inputs?: BreadcrumbsInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BreadcrumbsInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_breadcrumbs(inputs)
	return en_breadcrumbs(inputs)
});